// WP-STANDARD | PUBLIC CONTACT CHANNELS
// STATUS: HOTFIX_TESTED_STATIC · RUNTIME_PENDING
// Single source of truth for WebProfit-owned contact destinations. Tenant/business
// phone fields stay independent so changing support never overwrites client data.
export const WEBPROFIT_CALENDLY_URL = "https://calendly.com/montiverogianfranco2709/15min";
export const WEBPROFIT_WHATSAPP_NUMBER = "542604113045";
export const WEBPROFIT_WHATSAPP_URL = `https://wa.me/${WEBPROFIT_WHATSAPP_NUMBER}`;

// Stable helper for contextual CTAs. Keeping message composition here prevents
// future sales/support buttons from rebuilding WhatsApp URLs in separate screens.
export function buildWebProfitWhatsappUrl(message = "") {
  const normalizedMessage = String(message || "").trim();
  if (!normalizedMessage) return WEBPROFIT_WHATSAPP_URL;
  return `${WEBPROFIT_WHATSAPP_URL}?text=${encodeURIComponent(normalizedMessage)}`;
}

export function buildCalendlyEmbedUrl() {
  const params = new URLSearchParams({
    hide_gdpr_banner: "1",
    background_color: "ffffff",
    text_color: "19242f",
    primary_color: "f35a3a",
  });
  return `${WEBPROFIT_CALENDLY_URL}?${params.toString()}`;
}
